export default __webpack_public_path__ + "static/media/shower-rain-day.698e4f86.svg";